import { Link, useParams } from "react-router-dom";
import { Check, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function OrderSuccess() {
  const { orderNumber } = useParams();
  const [whatsapp, setWhatsapp] = useState("");

  useEffect(() => {
    api.get("/config").then(({ data }) => setWhatsapp(data.whatsapp)).catch(() => {});
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="order-success-page">
      <div className="w-16 h-16 mx-auto mb-6 bg-[#D27D60] rounded-full flex items-center justify-center">
        <Check className="w-6 h-6 text-[#FDFBF7]" strokeWidth={2} />
      </div>
      <div className="text-[11px] uppercase tracking-widest-plus text-[#D27D60] mb-3">✦ Order confirmed</div>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-tight mb-6">Thank you!</h1>
      <p className="text-lg text-[#4a4a4a] mb-2">Your order number is</p>
      <p className="font-serif-display text-3xl mb-8" data-testid="order-success-number">{orderNumber}</p>
      <p className="text-sm text-[#9BA595] max-w-md mx-auto mb-10">
        We've received your order. Our Howrah studio will hand-prepare each item and reach out to confirm delivery details shortly.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <Link
          to="/shop"
          className="bg-[#1A1A1A] text-[#FDFBF7] px-7 py-3.5 rounded-full text-sm uppercase tracking-widest-plus hover:bg-[#D27D60] transition-colors"
          data-testid="order-success-continue-btn"
        >
          Continue shopping
        </Link>
        {whatsapp && (
          <a
            href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(`Hi! I just placed order ${orderNumber}.`)}`}
            target="_blank"
            rel="noreferrer"
            className="border border-[#25D366] text-[#25D366] px-7 py-3.5 rounded-full text-sm uppercase tracking-widest-plus hover:bg-[#25D366] hover:text-white transition-colors flex items-center gap-2"
            data-testid="order-success-whatsapp-btn"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
            Message us
          </a>
        )}
      </div>
    </div>
  );
}
